import { render, staticRenderFns } from "./RolesManageView.vue?vue&type=template&id=4b5d5df4"
import script from "./RolesManageView.vue?vue&type=script&lang=js"
export * from "./RolesManageView.vue?vue&type=script&lang=js"
import style0 from "./RolesManageView.vue?vue&type=style&index=0&id=4b5d5df4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports